export enum Level{
	REPORT = 'REPORT',
	OPEN = 'OPEN',
	CLOSE = 'CLOSE',
}
